import React from 'react'
import DataItem from '../Components/DataItem/DataItem'
import Footer from '../Components/Footer/Footer'
import Header from '../Components/Header/Header'

const DataItemPage = ({data}) => {
  return (
    <div>
      <Header/>
      <div role="main" aria-label="Data Item">
    <DataItem data={data}/>
      </div>
      <Footer/>
    </div>
  )
}

export default DataItemPage